import {collection,getDocs,query,where} from 'firebase/firestore';
import {db} from './firebase';
import './public-media.css';

const imageUrl=url=>typeof url==='string'&&/^https:\/\/firebasestorage\.googleapis\.com\//.test(url);
const youtubeUrl=url=>typeof url==='string'&&/^https:\/\/www\.youtube-nocookie\.com\/embed\/[\w-]{11}$/.test(url);

function makeFigure(item){
 if(!Number.isFinite(item.width)||item.width<30||item.width>100)return null;
 const figure=document.createElement('figure');
 figure.className='hp-inserted-media';
 figure.style.setProperty('--media-width',`${item.width}%`);
 let media;
 if(item.type==='image'&&imageUrl(item.url)){
  media=document.createElement('img');media.src=item.url;media.alt=item.alt||'';media.style.objectPosition=`${item.position||50}% center`;
 }else if(item.type==='video'&&imageUrl(item.url)){
  media=document.createElement('video');media.src=item.url;media.controls=true;media.preload='metadata';media.playsInline=true;
 }else if(item.type==='youtube'&&youtubeUrl(item.url)){
  const poster=document.createElement('button');poster.type='button';poster.className='hp-youtube-poster';poster.setAttribute('aria-label',`Play ${item.title||'YouTube video'}`);const thumb=document.createElement('img');thumb.src=`https://i.ytimg.com/vi/${item.url.split('/').pop()}/hqdefault.jpg`;thumb.alt='';const play=document.createElement('span');play.textContent='▶';play.setAttribute('aria-hidden','true');poster.append(thumb,play);poster.addEventListener('click',()=>{const frame=document.createElement('iframe');frame.src=item.url+'?autoplay=1';frame.title=item.title||'YouTube video';frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;poster.replaceWith(frame)});media=poster;
 }else return null;
 figure.append(media);
 if(item.title){const caption=document.createElement('figcaption');caption.textContent=item.title;figure.append(caption)}
 return figure;
}

function videoHost(main,path){
 if(path==='/gaza')return main.querySelector('.gaza-video-grid');
 if(path==='/uganda/interior-ceilings')return main.querySelector('.ceiling-video-row');
 if(path.startsWith('/uganda/updates/'))return main.querySelector('.update-video-placeholders')||main.querySelector('.update-local-video')?.parentElement;
 return null;
}

export function startPublicMedia(path){
 if(!db)return ()=>{};
 let cancelled=false;
 getDocs(query(collection(db,'cmsMedia'),where('published','==',true))).then(snapshot=>{
  if(cancelled)return;
  const items=snapshot.docs.map(d=>d.data()).filter(item=>item.page===path).sort((a,b)=>a.order-b.order);
  if(!items.length)return;
  const main=document.getElementById('main');if(!main)return;
  main.querySelectorAll('.hp-inserted-media,.hp-page-media').forEach(node=>node.remove());
  const remaining=document.createElement('section');remaining.className='hp-page-media';remaining.setAttribute('aria-label','Page photos and videos');
  const host=videoHost(main,path);
  for(const item of items){const figure=makeFigure(item);if(!figure)continue;if(item.type!=='image'&&host)host.append(figure);else remaining.append(figure)}
  if(remaining.childElementCount)main.append(remaining);
 }).catch(()=>{});
 return()=>{cancelled=true;document.querySelectorAll('#main .hp-inserted-media,#main .hp-page-media').forEach(node=>node.remove())};
}
